import React from "react";
import { ArrowRight } from "lucide-react";
import "./profession.dashboard.css";


export default function ProfessionCard({
  title,
  icon: Icon,
  color,
  onClick
}) {
  return (
    <button
      type="button"
      className="pro-card"
      onClick={onClick}
      style={{
        "--card-accent": color
      }}
    >
      <div
        className="pro-icon"
        style={{ color }}
      >
        <Icon
          size={24}
          strokeWidth={2}
        />
      </div>

      <div className="pro-card-content">

        <span className="pro-card-type">
          PROFESSION
        </span>

        <h3>
          {title}
        </h3>

        <p className="pro-desc">
          Find {title.toLowerCase()}s and
          construction expertise
        </p>

      </div>

      <span
        className="pro-card-arrow"
        aria-hidden="true"
      >
        <ArrowRight size={17} />
      </span>
    </button>
  );
}